export default "__VITE_ASSET__CQgZ5JIj__"